export var TITLE = 'AlibabaCloud';
export var TEXT_MULTIPLE = 0.65;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#FF6A00';